const ExchangeRateMode = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL"
};

export default ExchangeRateMode;